<ng-container *ngIf="i18n.translations$ | async as translations">
  <label [class.full]="full" class="input-wrapper">

    <span class="label-text">
      {{ label }}
      @if (required) {
      <em>*</em>
      }
    </span>

    @if (type !== 'date') {
    <mat-form-field appearance="outline" class="full-width">
      @if (type === 'text') {
      <input matInput [id]="controlId" [type]="type || 'text'" [formControl]="control" (blur)="control.markAsTouched()"
        (input)="removeLeadingSpaces($event)" (keypress)="restrictSpecialChars($event)"
        (paste)="sanitizePaste($event)" />
      } @else if (type === 'password') {
      <input matInput [id]="controlId" [type]="passwordVisible ? 'text' : 'password'" [formControl]="control"
        (blur)="control.markAsTouched()" (copy)="$event.preventDefault()" (paste)="$event.preventDefault()"
        (cut)="$event.preventDefault()" />
      <mat-error *ngIf="control.hasError('serverError')">{{ control.getError('serverError') }}</mat-error> @if
      (hasPasswordValue()) {
      <button matSuffix class="password-toggle-btn" type="button" (click)="togglePasswordVisibility()"
        [attr.aria-label]="passwordVisible ? 'Hide password' : 'Show password'">
        @if (passwordVisible) {
        <svg class="password-eye-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20C7 20 2.73 16.89 1 12c.74-2.1 2.08-3.92 3.84-5.3" />
          <path d="M10.58 10.58a2 2 0 1 0 2.83 2.83" />
          <path d="M9.88 5.09A10.94 10.94 0 0 1 12 4c5 0 9.27 3.11 11 8a10.96 10.96 0 0 1-4.21 5.17" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
        } @else {
        <svg class="password-eye-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        }
      </button>
      }
      }
      @else if (type === 'email') {
      <input matInput [id]="controlId" [type]="type || 'email'" [formControl]="control" (blur)="onEmailBlur()" />
      }
      @else {
      <input matInput [id]="controlId" [type]="type || 'text'" [formControl]="control"
        (blur)="control.markAsTouched()" />
      }
    </mat-form-field>
    }

    @if (type === 'date') {
    <div class="date-wrapper">
      <div class="date-input-row" [class.has-error]="control.touched && control.invalid"
        [class.disabled]="control.disabled">
        <input type="text" class="date-text-input" [id]="controlId" [formControl]="control"
          [placeholder]="placeholder || 'dd/mm/yyyy'" maxlength="10" (input)="onDateInput($event)"
          (blur)="onDateBlur()" />
        <button type="button" class="cal-toggle-btn" (click)="toggleCalendar()" [disabled]="control.disabled">
          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-fill"
            viewBox="0 0 16 16" style="color: #a8aeb9;">
            <path
              d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5">
            </path>
          </svg>
        </button>
      </div>

      @if (calendarOpen) {
      <div class="custom-calendar">
        <!-- HEADER -->
        <div class="cal-header">
          <button type="button" class="cal-nav" (click)="prevUnit()">&#8249;</button>
          <button type="button" class="cal-title-btn" (click)="toggleView()">
            {{ calView === 'years' ? (calYearStart + ' – ' + (calYearStart + 11)) : (monthNames[calMonth] + ' ' +
            calYear) }}
          </button>
          <button type="button" class="cal-nav" [disabled]="isNextDisabled()" (click)="nextUnit()">&#8250;</button>
        </div>

        <!-- DAY VIEW -->
        @if (calView === 'days') {
        <div class="cal-grid">
          <span class="cal-day-label" *ngFor="let d of dayLabels">{{ d }}</span>
          <span class="cal-empty" *ngFor="let e of emptySlots"></span>
          <button type="button" class="cal-cell" *ngFor="let day of calDays" [class.today]="isToday(day)"
            [class.selected]="isSelected(day)" [class.disabled]="isFutureDate(day)" [disabled]="isFutureDate(day)"
            (click)="selectDay(day)">{{ day }}</button>
        </div>
        }

        <!-- MONTH VIEW -->
        @if (calView === 'months') {
        <div class="cal-month-grid">
          <button type="button" class="cal-month-cell" *ngFor="let m of monthNames; let i = index"
            [class.selected]="i === calMonth" [class.disabled]="isFutureMonth(i)" [disabled]="isFutureMonth(i)"
            (click)="selectMonth(i)">{{ m.slice(0, 3) }}</button>
        </div>
        }

        <!-- YEAR VIEW -->
        @if (calView === 'years') {
        <div class="cal-year-grid">
          <button type="button" class="cal-year-cell" *ngFor="let y of yearRange" [class.selected]="y === calYear"
            [class.disabled]="isFutureYear(y)" [disabled]="isFutureYear(y)" (click)="selectYear(y)">{{ y }}</button>
        </div>
        }
      </div>
      }
    </div>
    }

    @if (control.touched) {

    @if (control.hasError('required')) {
    <p class="error-message">
      {{
      i18n.t(
      translations,
      'errors.required',
      { field: label }
      )
      }}
    </p>
    }

    @if (control.hasError('pattern')) {
    <p class="error-message">
      {{ i18n.t(translations, 'errors.passwordPattern') }}
    </p>
    }

    @if (control.hasError('email')) {
    <p class="error-message">
      {{ i18n.t(translations, 'errors.invalidEmail') }}
    </p>
    }

    @if (control.hasError('emailMismatch')) {
    <p class="error-message">
      {{ i18n.t(translations, 'errors.emailMismatch') }}
    </p>
    }

    @if (control.hasError('passwordMismatch')) {
    <p class="error-message">
      {{ i18n.t(translations, 'errors.passwordMismatch') }}
    </p>
    }

    @if (control.hasError('minlength')) {
    <p class="error-message">
      {{
      i18n.t(
      translations,
      'errors.minLength',
      { length: control.getError('minlength')?.requiredLength }
      )
      }}
    </p>
    }

    @if (control.hasError('maxlength')) {
    <p class="error-message">
      {{
      i18n.t(
      translations,
      'errors.maxLength',
      { max: control.getError('maxlength')?.requiredLength }
      )
      }}
    </p>
    }

    @if (control.hasError('invalidLeapYearDate')) {
    <p class="error-message">
      {{ i18n.t(translations, 'errors.invalidLeapYearDate', { field: label }) }}
    </p>
    }

    @if (control.hasError('invalidDate')) {
    <p class="error-message">
      {{ i18n.t(translations, 'errors.invalidDate', { field: label }) }}
    </p>
    }

    }

  </label>
</ng-container>